// ToastContext.jsx

import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from "react";
 import GlobalToast from "./components/GlobalToast";

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const timerRef = useRef(null);

  const showToast = useCallback((msg, ms = 2000) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setMessage(msg);
    setShow(true);
    timerRef.current = setTimeout(() => {
      setShow(false);
      timerRef.current = null;
    }, ms);
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <GlobalToast message={message} show={show} />
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
